import React from 'react';
import PropTypes from 'prop-types';

export default function StructureToolbarCustomerIconTooltip({ customerLabel }) {
  return (
    <div>
      copy SMILES from <b>{customerLabel}</b>
    </div>
  );
}

StructureToolbarCustomerIconTooltip.propTypes = {
  customerLabel: PropTypes.string,
};
